import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import "../References/References.css";
import CMSTranslationFile from "../References/References_Translation_Corp.json";
import Image from "../../Assests/customer-references.webp";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";
let userSelectedLanguage;

class References extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }
  callback = () => {
    this.setState({
      reRender: true
    });
  };

  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar callBack={this.callback} />
        <div className="ID_References">
          <br></br>
          <br></br>
          <div
            style={{
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            <strong>
              {CMSTranslationFile.References_Title[userSelectedLanguage]}
            </strong>
            {/* References */}
          </div>
          <br></br>
          <section
            style={{
              // fontSize: "20px",
              textAlign: "left"
            }}
          >
            {CMSTranslationFile.References_Text1[userSelectedLanguage]}
            <br />
          </section>
          <br></br>
          <img src={Image} className="customerReferencesImage" />
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}
export default References;
